<script setup lang="ts">
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'
import type { WhoWeAreLaHausMediaComponentModule } from '@/components/BrandedV2/WhoWeAreLaHausMedia/types'

defineProps<WhoWeAreLaHausMediaComponentModule.Props>()
const { t, tm, rt } = useI18n()
const { $useLhId } = useNuxtApp()
const items: {name: string; description: string, image: string, link: string}[] = tm('items')

const handleCtaClick = (link: string) => {
  window.open(link, '_blank')
}

</script>

<script lang="ts">
export default {
  name: 'WhoWeAreLaHausMedia'
}
</script>

<template>
  <div class="bg-gray2-400 lg:py-90 py-56 px-24 lg:px-90 text-pine-600">
    <div class="max-w-screen-lg mx-auto">
      <h2 class="display-7 lg:display-4 text-center lg:mb-56 mb-40">
        {{ t('title') }}
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-16">
        <div
          v-for="(item, index) in items"
          :key="item.name"
          class="bg-white max-h-[340px] px-40 py-40 lg:px-48 lg:py-48 rounded-24">
          <img
            :src="rt(item.image)"
            :alt="rt(item.name)"
            class="max-h-[32px]">

          <p class="text-pine-600 lg:hl-3-sb body-1-sb lg:mt-40 mt-24 mb-24 lg:mb-40">
            {{ rt(item.description) }}
          </p>

          <RoomieButton
            :id="`who-we-are-la-haus-media-button-${rt(item.name)}-link`"
            :data-lh-id="$useLhId({ ...dataAttributes.dataLh, A: 'redireccionar', C: rt(item.name), I: index })"
            :aria-label="rt(item.name)"
            class="w-full"
            variant="primary"
            @click="handleCtaClick(rt(item.link))">
            {{ t('ctaText') }}
          </RoomieButton>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n src="./i18n.json" lang="json"></i18n>
